export const LISTATIPOCLASSIFICACAO = [
  {
    label: "Faturamento",
    value: "FATURAMENTO",
  },
  {
    label: "Custo Fixo",
    value: "CUSTO_FIXO",
  },
  {
    label: "Custo Variável",
    value: "CUSTO_VARIAVEL",
  },
];
